import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DEAL_ROOM_COLLEAGUE_ROLE,
  DEAL_ROOM_COLLEAGUE_ROLE_COPY,
  RWC_DEAL_ROOM_COLLEAGUE_ROLE_COPY,
} from 'models/DealRoom';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

export default function useColleagueRoles() {
  const { t } = useTranslation();

  const { isRWCMember } = useContext(CurrentUserContext);

  return useMemo(
    () =>
      Object.values(DEAL_ROOM_COLLEAGUE_ROLE).map((value) => ({
        value,
        label: t(
          (isRWCMember
            ? RWC_DEAL_ROOM_COLLEAGUE_ROLE_COPY
            : DEAL_ROOM_COLLEAGUE_ROLE_COPY)[value],
        ),
      })),
    [isRWCMember, t],
  );
}
